import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { APP_CONSTANTS } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class AuthStateService {
  // Authentication state management using BehaviorSubject
  private readonly _isAuthenticated$ = new BehaviorSubject<boolean>(this.getInitialAuthState());

  /**
   * Observable for authentication state
   * Components can subscribe to this to react to auth changes
   */
  public readonly isAuthenticated$: Observable<boolean> = this._isAuthenticated$.asObservable();

  constructor() {
    // Initialize auth state - no dependencies needed
  }

  /**
   * Get current authentication state
   */
  get isAuthenticated(): boolean {
    return this._isAuthenticated$.value;
  }

  /**
   * Update authentication state based on token presence
   */
  updateAuthState(): void {
    const token = localStorage.getItem('auth_token');
    const isAuth = !!token;
    this._isAuthenticated$.next(isAuth);
  }

  /**
   * Set authentication state to true
   */
  setAuthenticated(): void {
    this._isAuthenticated$.next(true);
  }

  /**
   * Set authentication state to false
   */
  setUnauthenticated(): void {
    this._isAuthenticated$.next(false);
  }

  /**
   * Get initial authentication state from storage
   * Follows business rules: check encrypted storage with key AppConstants.AUTHENTICATED
   */
  private getInitialAuthState(): boolean {
    try {
      // Check localStorage for authentication state
      const authState = localStorage.getItem(APP_CONSTANTS.AUTHENTICATED);
      return authState === 'true' && this.hasValidToken();
    } catch (error) {
      console.warn('Error reading auth state from storage:', error);
      return false;
    }
  }

  /**
   * Check if there's a valid token
   */
  private hasValidToken(): boolean {
    const token = localStorage.getItem('auth_token');
    return !!token;
  }

  /**
   * Clear authentication state and storage
   */
  clearAuthState(): void {
    this.setUnauthenticated();
    // Clear storage as per business rules
    localStorage.removeItem(APP_CONSTANTS.AUTHENTICATED);
    sessionStorage.clear();
  }
  public checkAuth: BehaviorSubject<string> = new BehaviorSubject<string>(
    localStorage.getItem(APP_CONSTANTS.AUTHENTICATED)|| "false"
  );
}